import { IApplicationState } from '../../../../../../../types/types';
import { TChatGroupId } from '../../../../../../../types/rest/IRestChatGroup';

export const getOpenedChatGroupId = (state: IApplicationState): TChatGroupId => {
    return state?.chatView?.openedGroupId;
}
